export const en_livescoreData = [
    {
        "sports_type": 1,
        "sports_type_label": "soccer",
        "sports_type_name": "축구",
        "url": "https://freelive.7msport.com/live.aspx?mark=en&TimeZone=AUTO&wordAd=&wadurl=//&width=700&cpageBgColor=FFFFFF&tableFontSize=11&cborderColor=DDDDDD&ctdColor1=FFFFFF&ctdColor2=E0E9F6&clinkColor=0044DD&cdateFontColor=333333&cdateBgColor=FFFFFF&scoreFontSize=12&cteamFontColor=000000&cgoalFontColor=FF0000&cgoalBgColor=FFFFE1&cremarkFontColor=0000FF&cremarkBgColor=F7F8F3&Skins=10&teamWeight=400&scoreWeight=700&goalWeight=400&fontWeight=700&DSTbox=",
        "side_url": "https://freelive.7msport.com/live.aspx?mark=en&TimeZone=AUTO&wordAd=&wadurl=//&width=400&cpageBgColor=FFFFFF&tableFontSize=11&cborderColor=DDDDDD&ctdColor1=FFFFFF&ctdColor2=E0E9F6&clinkColor=0044DD&cdateFontColor=333333&cdateBgColor=FFFFFF&scoreFontSize=12&cteamFontColor=000000&cgoalFontColor=FF0000&cgoalBgColor=FFFFE1&cremarkFontColor=0000FF&cremarkBgColor=F7F8F3&Skins=10&teamWeight=400&scoreWeight=3&goalWeight=400&fontWeight=700&DSTbox="
    },
    {
        "sports_type": 2,
        "sports_type_label": "baseball",
        "sports_type_name": "야구",
        "url": "https://bab.7m.com.cn/free_en.aspx?tz=AUTO"
    },
    {
        "sports_type": 3,
        "sports_type_label": "basketball",
        "sports_type_name": "농구",
        "url": "https://basket.7msport.com/free_en.aspx?tz=AUTO"
    },
    {
        "sports_type": 4,
        "sports_type_label": "americanfootball",
        "sports_type_name": "미식축구",
        "url": "https://amf.7msport.com/free_en.aspx?tz=AUTO"
    }
]